import UNISWAP_V2_HELPER_ABI from './uniswap-helper.json'

const UNISWAP_V2_HELPER_ADDRESS = '0xaf93aab3bf68ba81b814c228e771018fa0b4f5d9'

export { UNISWAP_V2_HELPER_ADDRESS, UNISWAP_V2_HELPER_ABI }
